






































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import SearchCase from '@/mixins/search-queries/search-case'
import SearchAccount from '@/mixins/search-queries/search-account'
import { taskRelationTypeValues } from '@/modules/Task/helpers/task'
import { TaskRelatedInput } from '@/modules/Task/interfaces/task'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class TaskFormRelated extends mixins(SearchPolicy, SearchCase, SearchAccount) {
  @Prop({ type: Array as () => Array<TaskRelatedInput> }) value!: TaskRelatedInput[]

  taskRelationTypeValues = taskRelationTypeValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }

  @Emit('delete')
  deleteHandler (index: number) {
    return index
  }
}
